import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"

export const SideCard = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
      portrait: file(relativePath: { eq: "me.png" }) {
        childImageSharp {
          gatsbyImageData(width: 480, placeholder: BLURRED)
        }
      }
    }
  `)
  const image = getImage(data.portrait)

  return (
    <Aside>
      {image ? <GatsbyImage image={image} alt={data.site.siteMetadata.author} /> : null}
      <h2>{data.site.siteMetadata.author}</h2>
      <p>
        Vill du stötta arbetet? En kaffe på{" "}
        <a href="https://ko-fi.com/khaledelhamzi" target="_blank" rel="noopener noreferrer">
          Ko-fi
        </a>{" "}
        eller ett medlemskap på{" "}
        <a href="https://www.patreon.com/khaledelhamzi" target="_blank" rel="noopener noreferrer">
          Patreon
        </a>{" "}
        gör skillnad.
      </p>
      <More to="/about">Mer om mig</More>
    </Aside>
  )
}

const Aside = styled.aside`
  display: none;

  @media ${props => props.theme.breakpoints.desktop} {
    display: block;
    align-self: start;
    overflow: hidden;
    border: 1px solid var(--border);
    border-radius: 1.75rem;
    background: var(--elevated);

    .gatsby-image-wrapper {
      display: block;
      aspect-ratio: 4 / 5;
    }

    h2 {
      margin: 1.15rem 1.25rem 0;
      font-size: 1.25rem;
    }

    p {
      margin: 0.6rem 1.25rem 0;
      color: var(--muted);
      font-size: 0.9rem;
      line-height: 1.55;
    }
  }
`

const More = styled(Link)`
  display: inline-block;
  margin: 1rem 1.25rem 1.25rem;
  font-size: 0.875rem;
  color: var(--accent);
`
